module.exports = __webpack_public_path__ + "img/fi-json.403f0ef2.svg";